export default {
  buttonRight: '1%',
};
